interface ArrowDownProps {
  bold?: boolean
}

export function ArrowDown({ bold = false }: ArrowDownProps): JSX.Element {
  return (
    <svg
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="arrowDown"
    >
      <path
        d="M1.15918 1.27588L5.15918 5.38688L9.15918 1.27588"
        className="stroke-svgColor"
        strokeWidth={bold ? '2.5' : '1'}
      />
    </svg>
  )
}
